module.exports = __webpack_public_path__ + "static/media/training.d81ae678.svg";